import React, { useState } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import Button from "../../../components/Button";
import { H4 } from "../../../styles/Fonts";
import CustomModal from "../../../components/Modal";
import { getTruncNum } from "../../../utils/common";
import { PoolProps } from "../../../utils/constant/pools";
import { useWeb3React } from "@web3-react/core";
import { withdrawTokenFromPool } from "../../../utils/api/lendingPoolApi";
import AmountInput from "../../../components/AmountInput";

type Props = {
  isShowModal: boolean;
  setShowModal: (v: boolean) => void;
  pool: PoolProps;
  updatePoolState: () => void;
  updateUserSupply: () => void;
  balance: number;
  setIsWithdrawing: (v: boolean) => void;
  updateTokenBalance: () => void;
};

const WithdrawModal: React.FC<Props> = (props) => {
  const {
    isShowModal,
    setShowModal,
    pool,
    updatePoolState,
    updateUserSupply,
    balance,
    setIsWithdrawing,
    updateTokenBalance,
  } = props;
  const { lendingPoolAddress: poolAddress, tokenSymbol, tokenDecimal } = pool;

  const [ethAmount, setEthAmount] = useState<number>(0);

  const { account, chainId, library } = useWeb3React();

  const handleWithdraw = async (address: string, amount: number) => {
    if (!chainId || !library) {
      return;
    }

    setShowModal(false);
    setIsWithdrawing(true);

    try {
      await withdrawTokenFromPool(
        address,
        poolAddress,
        tokenDecimal,
        tokenSymbol,
        amount,
        library
      );
      updatePoolState();
      updateUserSupply();
      updateTokenBalance();
    } catch (e) {
      console.log(e);
    }

    setIsWithdrawing(false);
    setEthAmount(0);
  };

  return (
    <CustomModal
      show={isShowModal}
      onHide={() => setShowModal(false)}
      title={"Withdraw"}
    >
      <AmountInput
        setAmount={setEthAmount}
        tokenSymbol={tokenSymbol}
        tokenDecimal={tokenDecimal}
        showMaxBtn={true}
        maxAmount={balance}
      />
      <InfoContainer>
        <BalanceRow>
          <Label>{"Pool Balance"}</Label>
          <Value>
            {getTruncNum(balance, tokenDecimal) || "-"}
            {" WETH"}
          </Value>
        </BalanceRow>
      </InfoContainer>
      <BtnContainer>
        <Button
          btnType="primary"
          btnText={"Withdraw"}
          onClick={() => (account ? handleWithdraw(account, ethAmount) : null)}
          disabled={!ethAmount}
          isLoading={false}
        />
      </BtnContainer>
    </CustomModal>
  );
};

export default WithdrawModal;

const InfoContainer = styled.div`
  margin-top: 20px;
`;

const Label = styled(H4)`
  color: ${Colors.gray3};
  font-size: 13px;
  line-height: 22px;
`;

const Value = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 28px;
  font-weight: bold;
  color: ${Colors.ivory};
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const BalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;

const BtnContainer = styled.div`
  margin-top: 20px;
  button {
    border-radius: 4px;
    font-size: 16px;
    line-height: 22px;
  }
`;
